import { createContext, ReactNode } from "react";

export const I18NContext = createContext<{ language: string }>({
  language: "en-US",
});

export interface I18NProviderProps {
  language: string;
  children?: ReactNode;
}

export function I18NProvider({ language, children }: I18NProviderProps) {
  return (
    <I18NContext.Provider value={{ language }}>{children}</I18NContext.Provider>
  );
}
